import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HeadingFour, HeadingTwo, MyDiv, Avatar } from "../Common/Components";
import { Box, IconButton, Tooltip, Drawer, Button, TextField } from "@mui/material";
import { Row, Col, Badge } from "react-bootstrap";
import { Edit } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FormProjects from "../NewProjects/form";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { postRequest } from "../Common/api/apiService";
import swal from "sweetalert2";
import CommonDataGrid from "../Common/commonDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { manageNewProjectsSlice } from "../ReduxToolkit/projectSlice.js";

const RolePermission = JSON.parse(localStorage.getItem("role"));

const { setPagination, setSortModel, setSearchText, resetState,resetPage} = manageNewProjectsSlice.actions;


export default function ManageNewProjects() {
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [data, setData] = useState("");
  const [projects, setProjects] = useState([]);
  const paginationModel = useSelector(state => state.manageNewProjects.pagination);
  const sortModel = useSelector(state => state.manageNewProjects.sortModel);
  const searchText = useSelector(state => state.manageNewProjects.searchText);
  const dispatch = useDispatch();

const loadProjects = useCallback(async () => {
  setLoading(true);
  const { page, pageSize } = paginationModel;
  const sortField = sortModel[0]?.field;
  const sortOrder = sortModel[0]?.sort;
  const sortQuery = sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : "";
  const searchQuery = searchText ? `&query=${encodeURIComponent(searchText)}` : "";

  const url = `fetchprojectslimited?page=${page}&limit=${pageSize}${sortQuery}${searchQuery}`;

  try {
    const response = await postRequest(url);
    if (response?.data) {
      setProjects(response.data.fetchedItems || []);
      setRowCount(response.data.totalItems || 0);
    }
  } catch (error) {
    console.error("Error loading projects:", error);
    swal.fire({
      text: error.response?.data?.message || "Failed to fetch projects.",
      icon: "error",
    });
  } finally {
    setLoading(false);
  }
}, [paginationModel, sortModel, searchText]);



  useEffect(() => {
    loadProjects();
  }, [loadProjects]);


  const [projectDrawerState, setProjectDrawerState] = React.useState(false);

  const handleProjectsDrawerToggle = () => {
    setData("");
    setProjectDrawerState(!projectDrawerState);
  };

  const projectEditId = _id => {
    setData(_id);
    setProjectDrawerState(true);
  };

  const updateDrawer = () => {
    setProjectDrawerState(false);
    loadProjects();
  };


const handleReset = () => {
  dispatch(resetState());   
};



  let navigate = useNavigate();

  const columns = [
    {
      field: "pro_name",
      headerName: "Project Name",
      flex: 1,
      renderCell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Avatar round="50px" size="40" name={row.pro_name} src={row.image ? `/${row.image}` : null} />
          {RolePermission?.ProjectManagement?.view === "1" ? (
            <Link to={`${row._id}`} className="TableLink">
              {row.pro_name}
            </Link>
          ) : (
            <MyDiv>{row.pro_name}</MyDiv>
          )}
        </div>
      ),
    },
    {
      field: "pro_code",
      headerName: "Code",
      flex: 1,
    },
    {
      field: "pro_owner_name",
      headerName: "Project Owner",
      flex: 1,
    },
    {
      field: "pro_startDate",
      headerName: "Start Date",
      flex: 1,
    },
    {
      field: "pro_endDate",
      headerName: "End Date",
      flex: 1,
    },
    {
      field: "pro_costCenter",
      headerName: "Cost Center",
      flex: 1,
    },
    {
  field: "pro_status",
  headerName: "Status",
  flex: 1,
  renderCell: ({ row }) => (
    <MyDiv>
      <Badge
        bg={
          row.pro_status?.toLowerCase() === "completed"
            ? "success"
            : row.pro_status?.toLowerCase() === "inprogress"
            ? "success"
            : row.pro_status?.toLowerCase() === "active"
            ? "success"
            : "danger"
        }
        text="light"
      >
        {row.pro_status}
      </Badge>
    </MyDiv>
  ),
},
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => (
        <Box className="custom-flex">
          {RolePermission?.ProjectManagement?.edit === "1" && (
            <Tooltip title="Edit">
              <IconButton onClick={() => projectEditId(row._id)}>
                <Edit />
              </IconButton>
            </Tooltip>
          )}
          {RolePermission?.ProjectManagement?.view === "1" && (
            <Link to={`${row._id}`}>
              <Tooltip title="View Project">
                <IconButton>
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
            </Link>
          )}
        </Box>
      ),
    },
  ];
  
const handleSortModelChange = model => {

  dispatch(setSortModel(model));
   dispatch(resetPage());
  loadProjects();
};

const handlePaginationModelChange = newModel => {
  dispatch(setPagination(newModel));
};
  return (
    <>

      <Row className="GeneralHeading">
        <Col md={6}>
          <HeadingTwo>
            <Link className="arrow-btn" onClick={() => navigate(-1)}>
              <ArrowBackIosIcon />
            </Link>
            Manage Projects
          </HeadingTwo>
        </Col>
        <Col md={6} className="text-end">
          {RolePermission?.ProjectManagement?.add === "1" && (
            <Button onClick={handleProjectsDrawerToggle} className="btn primary-btn">
              Add Project
            </Button>
          )}
        </Col>
      </Row>

      <Row className="SearchBar GeneralHeading mt-15">
        <Col md={12}>
          <Row>
            <Col md={6} className="SearchTextbox">
              <TextField
                placeholder="Search"
                variant="standard"
                fullWidth
                value={searchText}
                onChange={e => {
                  dispatch(resetState());
                  dispatch(setSearchText(e.target.value));
                }}
              />
            </Col>
            <Col md={6} className="text-start">
              <Button className="btn secondary-btn add-cta search mx-1" onClick={handleReset}>
                Reset
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      {loading ? (
        <HeadingFour className="text-center">Loading...</HeadingFour>
      ) : (

        <Row className="GeneralTable">
       
<CommonDataGrid
  rows={projects}
  columns={columns}
  rowCount={rowCount}
  loading={loading}
  paginationModel={paginationModel}
  onPaginationModelChange={handlePaginationModelChange}
  sortModel={sortModel}
  paginationMode="server"
  onSortModelChange={handleSortModelChange}
  getRowId={row => row._id}
/>


        </Row>
      )}

      <Drawer anchor="right" open={projectDrawerState} onClose={handleProjectsDrawerToggle}>
        <FormProjects handleClose={updateDrawer} projectEditId={data} />
      </Drawer>

    </>
  );
}
